<script lang="ts">
  import { page } from '$app/stores';
  import { Toasts } from 'svoast';
  import AppHeader from '$components/reusable/navigation/AppHeader.svelte';
  import '../app.css';
  import { toastPosition } from '$stores';
  import { getFlash } from 'sveltekit-flash-message';
  import { handleFormMessages } from '$utils/forms';
  import { QueryClientProvider } from '@tanstack/svelte-query';
  import type { LayoutData } from './$types';
  import { onMount } from 'svelte';
  import { afterNavigate, beforeNavigate } from '$app/navigation';
  import { SvelteQueryDevtools } from '@tanstack/svelte-query-devtools';
  import { appHeaderDisabledRoutes } from '$lib/routing-utils';

  export let data: LayoutData;

  const flash = getFlash(page);
  $: if ($flash) {
    handleFormMessages($flash);
  }

  // Automatically scroll to top of page after navigation
  let pathname = '';
  onMount(() => {
    pathname = $page.url.pathname;
  });
  beforeNavigate(() => {
    pathname = $page.url.pathname;
  });
  afterNavigate(() => {
    if (pathname === $page.url.pathname) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  });
</script>

<svelte:head>
  {#if $page.url.pathname.includes('/analytics')}
    <title>Colosseum Analytics</title>
    <meta
      name="description"
      content="Colosseum's analytics provides insights into the performance of hackathons, developer collaboration, and new startup formation."
    />
    <meta property="og:title" content="Colosseum Analytics" />
    <meta
      property="og:description"
      content="Colosseum's analytics provides insights into the performance of hackathons, developer collaboration, and new startup formation."
    />
    <meta
      property="og:image"
      content="https://static.narrative-violation.com/colosseum-analytics-2x.png"
    />
    <meta property="og:type" content="website" />
    <meta
      name="twitter:image"
      content="https://static.narrative-violation.com/colosseum-analytics-2x.png"
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content="@colosseum" />
  {:else if $page.url.pathname.includes('/hackathon/social-card')}
    <!-- Meta tags are handled dynamically in the /hackathon/social-card/+page.svelte file -->
  {:else}
    <title>Colosseum</title>
    <meta
      name="description"
      content="Colosseum's online platform powers hackathons, developer collaboration and new startup formation, all on Solana. Enter the Arena."
    />
    <meta property="og:title" content="Welcome to Colosseum" />
    <meta
      property="og:description"
      content="Powering Solana's online hackathons, new startup formation, and developer collaboration. Enter the Arena."
    />
    <meta
      property="og:image"
      content="https://static.narrative-violation.com/colosseum_og_card.png"
    />
    <meta property="og:type" content="website" />
    <meta
      name="twitter:image"
      content="https://static.narrative-violation.com/colosseum_og_card.png"
    />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content="@colosseum" />
  {/if}
</svelte:head>

<Toasts position={$toastPosition} />
<!-- {#if $page.url.pathname === '/analytics'}
  <Banner />
{/if} -->
{#if !appHeaderDisabledRoutes.some((route) => route.test($page.url.pathname))}
  <AppHeader />
{/if}
<QueryClientProvider client={data.queryClient}>
  <slot />
  <SvelteQueryDevtools />
</QueryClientProvider>
